import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectStatusesCount } from '@reducers/machinesV2';
import { getStatusSegments, StatusSegment } from '@v2/pages/machines/common/helpers/getStatusSegments';
import { UseManageMachineStatusGaugeParams } from '@v2/pages/machines/common/components/MachineStatusGauge/types';

export const useManageMachineStatusGauge = ({ C }: UseManageMachineStatusGaugeParams) => {
  const statusesCount = useSelector(selectStatusesCount);

  const segments: StatusSegment[] = useMemo(() => getStatusSegments(C, statusesCount), [C.scheme, statusesCount]);

  const totalMachines = useMemo(() => segments.reduce((sum, s) => sum + (s.count || 0), 0), [segments]);

  const activeSegments = useMemo(() => segments.filter((s) => s.count > 0), [segments]);

  return { segments, activeSegments, totalMachines };
};
